module.exports = __webpack_public_path__ + "static/media/downChevron.17088528.svg";